<!--
Author: TangChen
Date: 2018-10-22
Desc: 现金宝取现，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-redemption bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/xjbfund' }">
                    现金宝
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="取现渠道：" prop="id" class="payway-list">
                <el-radio-group v-model="fundInfo.id" class="bank-radio">
                    <el-radio
                        v-for="bank in bankLists"
                        :key="bank.transactionaccountid+bank.fundcode"
                        :label="bank.transactionaccountid+bank.fundcode"
                        border
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.paycenterid!==$util.getConfig().const.ZX_CENTER?bank.bankid:'hf')">
                            <div class="k-text-flow">
                                <span class="bank-name" :title="bank.channelname">{{ bank.channelname }}</span>总额(元)：<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.availablevol) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="可用金额：" class="form-text red">
                <div class="text-con">
                    {{ $util.fmtNum(fundInfo.availablevol)+'元' }}
                </div>
            </el-form-item>
            <el-form-item label="取现方式：" prop="sell" class="payway-list">
                <el-radio-group v-model="fundInfo.sell">
                    <el-radio label="0" name="sell">
                        普通取现<span>(T+1日到账，多一天收益)</span>
                    </el-radio>
                    <el-radio v-if="bankInfo.fastflag&&bankInfo.fastflag.indexOf('1')>-1" label="1" name="sell">
                        快速取现<span>(预计2小时到账，不享受当天收益)</span>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="取现金额：" prop="amount" class="redemp-amount">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                />
                <span v-if="!isAmountAll" class="redemp-btn" v-on:click="allSell"><span
                    class="like-a"
                    v-on:click="allSell"
                >全部取现</span></span>
                <p class="redemp-prompt">
                    <i class="el-icon-warning" />当日存入的金额，下一工作日方可快速转出
                </p>
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="20"
                />
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button type="primary" class="medium" v-on:click="submitInfo('fundInfo')">
                        确认取现
                    </el-button>
                    <el-button class="medium" v-on:click="$router.push('/currencyfund')">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <result v-if="buySuccess" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'traderecord'})" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
export default {
    name: "CurrencyRedemption",
    components: {
        result
    },
    mixins: [mixin],
    data () {
        return {
            fundInfo: {
                availablevol: "",
                amount: "",
                id: "",
                sell: "0",
                pwd: ""
            },
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请先选择取现渠道",
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "",
                special: false,
                btnL: {
                    text: "继续取现",
                    event: "return-page"
                },
                btnR: {
                    text: "查看记录",
                    event: "return-login"
                },
                btnGroup: [{
                    tit: "申请成功",
                    text: "取现业务已受理成功",
                    btn: "现金宝充值",
                    url: "currencycharge"
                }, {
                    tit: "T+0到账",
                    text: "快速取现，最快1秒到账",
                    btn: "继续取现",
                    url: "return"
                }, {
                    tit: "预计时间",
                    text: "预计到账：2018-10-25， 如遇节假日则顺延",
                    btn: "查看交易记录",
                    url: "traderecord"
                }]
            },
            query: null,
            bankLists: [],
            rules: {
                amount: [
                    { required: true, message: "请输入取现金额", trigger: "blur" },
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                sell: [
                    { required: true, message: "请选择取现方式", trigger: "change" }
                ],
                id: [
                    { required: true, message: "请选择取现渠道", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            limit: { min: "0.01", max: "0", text: "赎回份额范围为：" },
            ZX_CENTER_ID: "",
            bankInfo: {},
            limitObj: {}
        };
    },
    watch: {
        "fundInfo.id" (val) {
            this.bankInfo = this.bankLists.filter(item => {
                return item.transactionaccountid + item.fundcode === val;
            })[0];
            if (this.bankInfo.fastflag && this.bankInfo.fastflag.indexOf("1") > -1) {
                this.$set(this.fundInfo, "sell", "0");
            }
            this.getLimit(true);
        },
        "fundInfo.sell" () {
            this.getLimit();
            this.$refs.fundInfo.validateField("amount");
        },
        "fundInfo.amount" (val) {
            this.isAmount(val);
        }
    },
    mounted () {
        this.isPwdCheck = this.$cache.getPwdCheck("24");
        this.ZX_CENTER_ID = this.$util.getConfig().const.ZX_CENTER;
        this.getXjbInfo();
    },
    methods: {
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    const data = {
                        fastflag: _this.fundInfo.sell,
                        channelid: _this.bankInfo.channelid,
                        amount: _this.fundInfo.amount,
                        fundcode: _this.bankInfo.fundcode,
                        transid: _this.bankInfo.transactionaccountid,
                        tpasswd: this.$util.enc(_this.fundInfo.pwd)
                    };
                    _this.$util.request("xjb/withdraw", data, "POST").then(res => {
                        if (res.data) {
                            this.result.cla = "register-success";
                            this.result.special = true;
                            this.result.btnGroup[2].text = "预计到账：" + this.$util.fmtDate(res.data[0].cfmdate) + "， 如遇节假日则顺延";
                        } else {
                            this.result.cla = "register-fail";
                            this.result.btnMsg = "原因：" + res.msg;
                        }
                        this.result.msg = "您的取现申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
                        this.buySuccess = true;
                    });
                } else {
                    return false;
                }
            });
        },
        // 全部取现处理
        allSell () {
            this.fundInfo.amount = this.fundInfo.availablevol;
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                if (this.fundInfo.amount === this.fundInfo.availablevol) {
                    this.isAmountAll = true;
                } else {
                    this.isAmountAll = false;
                }
            }, 1);
        },
        reset () {
            this.buySuccess = false;
            this.result.special = false;
            this.bankInfo = {};
            this.$refs.fundInfo.resetFields();
            this.getXjbInfo();
        },
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        getXjbInfo () {
            const _this = this;
            this.$util.request("xjb/withdraw/assetdetail").then(res => {
                if (res.data) {
                    _this.bankLists = res.data[0].filter(item => {
                        return item.paycenterid !== _this.ZX_CENTER_ID;
                    });
                    _this.bankLists = _this.bankLists.filter(item => {
                        return item.availablevol > 0;
                    });
                    if (_this.bankLists.length === 0) {
                        this.$alert("暂无可取现现金宝份额！", "现金宝取现提示", {
                            confirmButtonText: "返回",
                            type: "warning",
                            center: true,
                            callback: action => {
                                _this.$router.back();
                            }
                        }).then(() => {
                            return false;
                        }).catch(() => {
                            return false;
                        });
                        return false;
                    }
                    _this.limitObj = res.data[1][0];
                    _this.$set(_this.fundInfo, "id", _this.bankLists[0].transactionaccountid + _this.bankLists[0].fundcode);
                    _this.$set(_this.fundInfo, "availablevol", _this.bankLists[0].availablevol);
                }
            });
        },
        // 限额更新
        getLimit (id) {
            let _max = this.fundInfo.sell === "0" ? this.limitObj.normalmax : this.limitObj.fastmax;
            const _min = this.fundInfo.sell === "0" ? this.limitObj.normalmin : this.limitObj.fastmin;
            _max = Number(_max) > Number(this.bankInfo.availablevol) ? this.bankInfo.availablevol : _max;
            // 取现银行卡改变更新可用值
            if (id) this.$set(this.fundInfo, "availablevol", this.bankInfo.availablevol);
            this.$set(this.limit, "max", _max);
            this.$set(this.limit, "min", _min);
            this.pla = "限额" + this.$util.fmtNum(this.limit.min) + "元 ~ " + this.$util.fmtNum(_max) + "元";
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-redemption {
    padding-bottom: 30px;
}
</style>
